import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';

import { getFullPath } from '../../utils/globalUtils';

const RedirectToPage = ({ path }) => <Redirect to={getFullPath(path)} />;

RedirectToPage.propTypes = {
  path: PropTypes.string.isRequired,
};

export default RedirectToPage;
